export default __webpack_public_path__ + "static/media/ovary_qc.5965f3f1.jpg";